export default "__VITE_ASSET__Gs7wZ20___"